import { render, staticRenderFns } from "./indexDataShow.vue?vue&type=template&id=24917587&scoped=true&"
import script from "./indexDataShow.vue?vue&type=script&lang=js&"
export * from "./indexDataShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24917587",
  null
  
)

export default component.exports